// TODO: Temporary solution
const getAvgAPY = () => 14

export default {
  getAvgAPY,
}
